export const Svg_077 = () => (
  <svg width={70} height={70} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={31.2}
        x2={11.8}
        y1={22.8}
        y2={50.4}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={55.5}
        x2={39.5}
        y1={14.6}
        y2={37.5}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.7}
        x2={44.5}
        y1={42.6}
        y2={54.3}
        data-name="Gradiente sem nome 3"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M33.9 35.5c-.4-.7-.9-1.3-1.5-1.8 1-1.2 1.5-2.6 1.5-4.1 0-2.8-1.8-5.3-4.4-6.2V23c0-4.2-3.4-7.6-7.6-7.6s-7.6 3.4-7.6 7.6v.4c-2.6.9-4.4 3.4-4.4 6.2s.5 3 1.5 4.1c-1.6 1.4-2.6 3.5-2.6 5.7 0 4.2 3.4 7.6 7.6 7.6h4.4v6.5c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1V47h4.4c1.4 0 2.8-.4 3.9-1.1.5-.3.7-1 .4-1.5-.3-.5-1-.7-1.5-.4-.8.5-1.8.8-2.8.8H23v-6.1l3-3c.4-.4.4-1.1 0-1.5s-1.1-.4-1.5 0l-1.4 1.4v-2.8c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v5.5l-1.3-1.8c-.4-.5-1-.6-1.5-.2-.5.4-.6 1-.2 1.5l3.1 4.1v2.9h-4.4c-3 0-5.4-2.5-5.4-5.5s1-3.6 2.6-4.6c.3-.2.5-.5.5-.9s-.1-.7-.4-.9c-1-.8-1.6-2.1-1.6-3.4 0-2.1 1.5-3.9 3.6-4.3.6-.1 1-.7.9-1.3v-1c0-3 2.4-5.4 5.4-5.4s5.5 2.4 5.5 5.4v1c-.1.6.3 1.1.9 1.3 2.1.4 3.6 2.2 3.6 4.3s-.6 2.5-1.6 3.4c-.3.2-.4.6-.4.9 0 .4.2.7.5.9.8.5 1.4 1.1 1.8 1.8.3.5 1 .7 1.5.4s.7-1 .4-1.5Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M59 43.8v-6.5c0-1.2-1-2.2-2.2-2.2H38.3c-1.2 0-2.2 1-2.2 2.2v6.5c-1.2 0-2.2 1-2.2 2.2v2.2c0 1.2 1 2.2 2.2 2.2v3.3c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-3.3h18.5v3.3c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-3.3c1.2 0 2.2-1 2.2-2.2V46c0-1.2-1-2.2-2.2-2.2Zm-20.7 0v-2.2h18.5v2.2H38.3Zm18.5-6.6v2.2H38.3v-2.2h18.5ZM59 48.1H36.1v-2.2H59v2.2Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M40.7 25.2h16.1c.7 0 1.3-.3 1.7-.8.4-.5.6-1.1.5-1.8-.2-1-.7-1.8-1.3-2.5-.9-.9-2.1-1.4-3.4-1.4-.9-2-2.8-3.3-5-3.3s-4.2 1.3-5 3.3c-1.6-.1-3.2.4-4.3 1.6-.6.6-1 1.3-1.3 2.1-.2.7-.1 1.4.3 2 .4.6 1.1.9 1.8.9Zm.7-3.4c.6-.6 1.4-.9 2.3-.9s.6 0 .9.1c.3 0 .6 0 .9-.1.3-.2.4-.4.5-.7.3-1.5 1.7-2.6 3.2-2.6s2.8 1 3.2 2.5c.1.6.7.9 1.3.8.9-.2 1.8.1 2.4.8.4.4.6.9.8 1.4H40.8c.2-.5.4-.9.8-1.2Z"
      style={{
        fill: "url(#c)",
      }}
    />
  </svg>
)